import { Group, Line, Material, Mesh, Points } from "three";

export const disposeGroup = (group: Group) => {

    if (group.parent)
        group.parent.remove(group);

    group.traverse((child)  => {
        if (child instanceof Mesh) {
            const childMesh = child as Mesh;

            disposeMaterials(childMesh.material);
            
            childMesh.geometry.dispose();
            
        }
        else if (child instanceof Line) {
            const childLine = child as Line;

            disposeMaterials(childLine.material);
            
            childLine.geometry.dispose();
        }
        else if (child instanceof Points) {
            const childPoints = child as Points;

            disposeMaterials(childPoints.material);

            childPoints.geometry.dispose();
        }
        else if (child instanceof Group) {
            // Do nothing, since traverse handles groups automatically
        }
        else {
            console.error(`SceneGeometry.disposeGroup: Unsupported object type ${child.type} for disposal.`);
        }
    });

    group.clear();
}

export const disposeMaterials = (materials: Material | Material[]) => {
    const materialsArray = Array.isArray(materials) ? materials : [materials];
    materialsArray.forEach(material => {
        material.dispose();
    });
}